export const nodeEnv = process.env.NODE_ENV;

export const cdnUrl = process.env.GATSBY_CDN_URL ?? "https://cdn.dealberg.com";

export const baseUrl =
  process.env.GATSBY_API_URL ??
  // "https://ci0gndhod3.execute-api.ap-south-1.amazonaws.com";
  // "https://gnug5ja9r2.execute-api.ap-south-1.amazonaws.com";
  "https://api.dealberg.com";

export const postHogKey = process.env.GATSBY_POSTHOG_KEY as string;
export const postHogHost = process.env.GATSBY_POSTHOG_HOST;
export const facebookPixelId = process.env.GATSBY_FACEBOOK_PIXEL_ID;
